export const ImageFormats = {
    JPEG: '.jpeg',
    JPG: '.jpg',
    PNG: '.png',
    GIF: '.gif',
    BMP: '.bmp',
    WEBP: '.webp',
    TIFF: '.tiff',
    SVG: '.svg',
    ICO: '.ico',
    ANY: ['.jpeg', '.jpg', '.png', '.gif', '.bmp', '.webp', '.tiff', '.svg', '.ico']
};
